<svg height="20" width="20" fill="none" viewBox="4 -7 11 33" xmlns="http://www.w3.org/2000/svg">
    <g>
        <circle fill="#fff" stroke="#4286f0" cx="9.5" cy="9.5" r="10" stroke-width="1"/>
        <circle fill="#4286f0" cx="9.5" cy="9.5" r="7"/>
    </g>
</svg>
